/* istanbul ignore file */
import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import ErrorBanner from '@avtechsoftware/react-component-library/src/components/common/ErrorBanner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function DevicePublicLinkModal(props) {
  const {
    onClose,
    initialPublicLinkUrl,
    userHasEditPrivileges,
    onDeletePublicLink,
    onCreatePublicLink,
    isLoading,
  } = props;

  const [publicLinkUrl, setPublicLinkUrl] = useState(initialPublicLinkUrl);
  const [error, setError] = useState('');

  const handleRefreshPublicLink = async () => {
    setError('');
    try {
      const newLink = await onCreatePublicLink();
      if (newLink) {
        setPublicLinkUrl(newLink);
      } else {
        setError('Error creating public link. Please try again.');
      }
    } catch (err) {
      setError('Error creating public link. Please try again.');
    }
  };

  const handleDeletePublicLink = async () => {
    setError('');
    try {
      const success = await onDeletePublicLink();
      if (success) {
        setPublicLinkUrl('');
      } else {
        setError('Error deleting public link. Please try again.');
      }
    } catch (err) {
      setError('Error deleting public link. Please try again.');
    }
  };

  const focusInput = (input) => {
    if (input) {
      input.focus();
    }
  };

  return (
    <Modal
      show={onClose}
      onHide={onClose}
      animation={false}
    >
      <Modal.Header>
        <div className="row">
          <div className="col mx-auto text-center">
            <h3>Public Link</h3>
          </div>
        </div>
      </Modal.Header>
      <Modal.Body>
        {error && (
          <div className="row">
            <div className="col">
              <ErrorBanner onCloseError={() => setError('')}>
                {error}
              </ErrorBanner>
            </div>
          </div>
        )}
        <div className="row">

          <div className="col mx-auto text-center">
            Anyone with this public link will be able to view this report.
          </div>
        </div>
        <div className="row form-inline">
          <div className="col mx-auto text-center">
            {publicLinkUrl ? (
              <>
                <span className="text-muted mr-1">
                  <FontAwesomeIcon icon="share-nodes" />
                  Public Link
                </span>
                <input
                  id="public-link-input"
                  className="form-control-sm"
                  type="text"
                  value={publicLinkUrl}
                  readOnly
                  onFocus={(e) => e.target.select()}
                  ref={focusInput}
                />
                {userHasEditPrivileges && (
                <>
                  <button type="button" className="btn p-1" onClick={handleRefreshPublicLink} disabled={isLoading}>
                    <FontAwesomeIcon icon="arrows-rotate" size="1x" />
                  </button>
                  <button type="button" className="btn p-1" onClick={handleDeletePublicLink} disabled={isLoading}>
                    <FontAwesomeIcon icon="trash-can" size="1x" />
                  </button>
                </>
                )}
              </>
            ) : (
              <button
                type="button"
                className="btn btn-sm btn-outline-dark mt-1"
                onClick={handleRefreshPublicLink}
                disabled={!userHasEditPrivileges}
              >
                <FontAwesomeIcon icon="share-nodes" size="1x" />
                {' '}
                Enable Public Link
              </button>
            )}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="row">
          <div className="col ml-auto">
            <Button
              variant="secondary"
              onClick={onClose}
            >
              Done
            </Button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

DevicePublicLinkModal.defaultProps = {
  // userHasEditPrivileges: true,
  initialPublicLinkUrl: '',
};

DevicePublicLinkModal.propTypes = {
  initialPublicLinkUrl: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  userHasEditPrivileges: PropTypes.bool.isRequired,
  onCreatePublicLink: PropTypes.func.isRequired,
  onDeletePublicLink: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default DevicePublicLinkModal;
